import { Alert } from '@mui/material';
import Snackbar, { type SnackbarCloseReason } from '@mui/material/Snackbar';
import { useEffect, useState } from 'react';
import { autoHideDuration } from '../../constants';
import { SnackBarComponentProps } from '../../types';

const SnackBarComponent = ({
  message,
  isOpen,
  severity = 'success',
  variant = 'standard',
  ...rest
}: SnackBarComponentProps) => {
  const [open, setOpen] = useState(isOpen);

  const handleClose = (
    _?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Snackbar
      {...rest}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant={variant}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBarComponent;
